document.addEventListener("turbolinks:load", function () {
    if (document.querySelector("#create-assignment-dropdown-toggle-button")) {
        setUpDropdown("#create-assignment-dropdown-toggle-button", ".assignments__create-dropdown-content");
    }
});